// Package Imports

// Internal Imports

export enum EMixPanelMetadataKeys {
  AUTH_TYPE = "authType",
  DEPLOY_STAGE = "deployStage"
}

export enum EMixPanelAuthTypes {
  WEB_LOGIN_BASE = "web_login_only",
  WEB_LOGIN_MFA = "web_login_with_mfa"
}
